import { render, staticRenderFns } from "./HeaderFiltersProvider.vue?vue&type=template&id=6859fe95"
import script from "./HeaderFiltersProvider.vue?vue&type=script&lang=js"
export * from "./HeaderFiltersProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports